import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'

const LineSeparator = ({ width = false, variant = [] }) => (
  <div
    style={width ? { width: width } : {}}
    className={withModifiers('separator', [...variant], styles)}
  ></div>
)

export default LineSeparator
